const TableDataCell = ({ className, children }) => {
  return <p className={`${className} border-b border-b-[#EBECF1] p-2 px-3`}>{children}</p>
}

export default TableDataCell
